import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  rootFormControl: {
    width: "inherit",
    paddingTop: theme.spacing(0)
  },
  selectedChipContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  multiplechipdel: {
    padding: "0px",
    backgroundColor:  theme.palette.background.paper,
  },
  multiplechipdelpadding: {
    padding: "0px"
  },
}));
